module.exports = __webpack_public_path__ + "img/registerCode.7122d89f.png";